"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIssueSubscriptionMutation = exports.useGetClientSubscriptionsQuery = exports.useGetUserSubscriptionsQuery = exports.subscriptionsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var base_query_1 = require("./base_query");
var subscriptionsApi = (0, react_1.createApi)({
    reducerPath: "subscriptionsApi",
    baseQuery: (0, base_query_1.authorisedBaseQuery)((_a = process.env.LETS_TRADE_PRODUCT_URL) !== null && _a !== void 0 ? _a : ""),
    refetchOnMountOrArgChange: 30,
    refetchOnFocus: true,
    tagTypes: ["ClientSubscription", "Subscription"],
    endpoints: function (builder) { return ({
        getUserSubscriptions: builder.query({
            query: function (args) { return ({ url: "v2/user/subscriptions", params: args }); },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : { subscription_list: [], count: 0 }; },
            providesTags: function (_result, _error, args) { return [{ type: "Subscription", id: args.user_id }]; },
        }),
        // the route validates its query keys strictly, so only the three it declares may be sent
        getClientSubscriptions: builder.query({
            query: function (_a) {
                var page = _a.page, size = _a.size, search_string = _a.search_string;
                return ({ url: "v2/client/subscription/list", params: { page: page, size: size, search_string: search_string } });
            },
            transformResponse: function (response) {
                var _a, _b;
                var content = (0, base_query_1.unwrapEnvelope)(response);
                return { items: (_a = content === null || content === void 0 ? void 0 : content.subscription_list) !== null && _a !== void 0 ? _a : [], count: (_b = content === null || content === void 0 ? void 0 : content.count) !== null && _b !== void 0 ? _b : 0 };
            },
            providesTags: ["ClientSubscription"],
        }),
        issueSubscription: builder.mutation({
            query: function (body) { return ({ url: "product/issue_subscription", method: "POST", body: body }); },
            invalidatesTags: function (_result, _error, _a) {
                var user_id = _a.user_id;
                return [{ type: "Subscription", id: user_id }];
            },
        }),
    }); },
});
exports.subscriptionsApi = subscriptionsApi;
var useGetUserSubscriptionsQuery = subscriptionsApi.useGetUserSubscriptionsQuery, useGetClientSubscriptionsQuery = subscriptionsApi.useGetClientSubscriptionsQuery, useIssueSubscriptionMutation = subscriptionsApi.useIssueSubscriptionMutation;
exports.useGetUserSubscriptionsQuery = useGetUserSubscriptionsQuery;
exports.useGetClientSubscriptionsQuery = useGetClientSubscriptionsQuery;
exports.useIssueSubscriptionMutation = useIssueSubscriptionMutation;
